import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHypertrackerApiMenuItem = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 11,
	viewBox: "0 0 12 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.33335 2.66675L0.666687 5.33341L3.33335 8.00008M8.66669 8.00008L11.3334 5.33341L8.66669 2.66675M7.33335 0.666748L4.66669 10.0001",
		stroke: "currentColor",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHypertrackerApiMenuItem;
